import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../../utils/with-router-props'

import SHSForm from '../../../utils/shs-form'
import InputElement from '../../../utils/input'
import { callApi, fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'
import AccountSidebar from '../../../shared/account-sidebar'
// import { TZ_CONFIG } from '../../../constants/tz-config'

const mapStateToProps = (state, ownProps) => {
    const account = state.adminAccounts.find(acc => acc.id === Number(ownProps.params.accountId))
    return {
        roles: state.roles,
        account
    }
}

const AdminUsersCreate = ({ dispatch, navigate, params, roles, account }) => {
    const accountId = params.accountId

    useEffect(() => {
        if (accountId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('roles', 'LIST')))
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'VIEW', accountId)))
        }
    }, [dispatch, accountId])


    const submitFX = (formData, formId) => {
        formData.accountId = accountId
        dispatch(callApi(apiResourceEndpoint('admin/users', 'CREATE'), formData, formId))
    }

    const successFX = (userId) => {
        navigate(buildRoutePath(routes.adminUsersView.path, { accountId, userId }))
    }

    const roleOptions = roles.slice()
        .sort((a, b) => {
            if (a.level > b.level) {
                return -1
            }
            return 1
        })
        .map(role => ({ value: role.id, label: role.name }))

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Dashboard for {account.name}</h1>
                        <p>Use the form below to create a new user and add to account.</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sidebar-layout">
                    <div className="sidebar box">
                        <AccountSidebar account={account} />
                    </div>
                    <div className="main-content box">
                        <SHSForm extraClass="flex-form" submitFX={submitFX} successFX={successFX}>
                            <InputElement
                                type="text"
                                id="firstName"
                                label="First Name"
                                placeholder="John"
                                extraClass="flex-33"
                                required />
                            <InputElement
                                type="text"
                                id="lastName"
                                label="Last Name"
                                placeholder="Doe"
                                extraClass="flex-33"
                                required />
                            <InputElement
                                type="email"
                                id="email"
                                label="Email"
                                placeholder="user@domain.com"
                                extraClass="flex-50"
                                required />
                            <InputElement
                                type="text"
                                id="password"
                                label="Password"
                                placeholder="myPassword123"
                                extraClass="flex-50"
                                required />
                            <InputElement
                                type="valueSelect"
                                id="roleId"
                                label="Role"
                                options={roleOptions}
                                extraClass="flex-50"
                                required />
                        </SHSForm>
                    </div>
                </div>
            </div>
        </div>
        // <div className="installation-wrapper">
        //     <div className="container">
        //         <div className="admin-header-wrapper">
        //             <h2>Use the form below to create a new user and add to account.</h2>
        //         </div>
        //         <div className="admin-layout sidebar">
        //             <AccountSidebar account={account} />
        //             <div className="admin-main-content">
        //                 <SHSForm extraClass="flex-form" submitFX={submitFX} successFX={successFX}>
        //                     <InputElement
        //                         type="text"
        //                         id="firstName"
        //                         label="First Name"
        //                         placeholder="John"
        //                         extraClass="flex-33"
        //                         required />
        //                     <InputElement
        //                         type="text"
        //                         id="lastName"
        //                         label="Last Name"
        //                         placeholder="Doe"
        //                         extraClass="flex-33"
        //                         required />
        //                     <InputElement
        //                         type="email"
        //                         id="email"
        //                         label="Email"
        //                         placeholder="user@domain.com"
        //                         extraClass="flex-50"
        //                         required />
        //                     <InputElement
        //                         type="text"
        //                         id="password"
        //                         label="Password"
        //                         placeholder="myPassword123"
        //                         extraClass="flex-50"
        //                         required />
        //                     <InputElement
        //                         type="valueSelect"
        //                         id="roleId"
        //                         label="Role"
        //                         options={roleOptions}
        //                         extraClass="flex-50"
        //                         required />
        //                 </SHSForm>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminUsersCreate))
